<script>
import {mapGetters} from "vuex";
import store from "@/store";

export default {
  name: "ShoppingCartWrapper",
  props: {
    user: {
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      products: "ShoppingCart/getUserOrderUnpaidItems",
      order: "ShoppingCart/getSidebarBasketData",
      deliveryPrice: 'ShoppingCart/getDeliveryPrice',
      deliveryBoundary: 'ShoppingCart/getDeliveryBoundary',
      freeCities: 'ShoppingCart/getFreeCities',
      payDescript: 'ShoppingCart/getPayDescript',
      addresses: "Address/getAddresses",
    }),
  },
  methods: {
    async setUnPayedOrder() {
      await this.$store.dispatch("ShoppingCart/userOrderUnpaid")
      this.$emit('order', this.order)
    },
    async setAddress() {
      await this.$store.dispatch("Address/getOrderAddresses");
    },
    async getUnAuthBasketItems() {
      if (localStorage.getItem('products') !== null) {

        let productsJson = JSON.parse(localStorage.getItem('products'))
        let form = new FormData();
        let counter = 0;

        Object.keys(productsJson).forEach(function (key) {
          form.append(`product[${counter}][id]`, productsJson[key]['id'])
          if (productsJson[key]['sub_product_id'] > 0) {
            form.append(`product[${counter}][sub_product]`, productsJson[key]['sub_product_id'])
          }
          counter += 1;
        })

        let user_id = this.$store.getters['User/getUserId']
        store.dispatch("ShoppingCart/addItemWithoutState", {user_id, form}).then(res => {
          const shoppingCart = res.data.data;
          const order_id = shoppingCart.id;
          const items = shoppingCart.items;


          // find local storage item in shopping cart items
          items.forEach(item => {
            Object.keys(productsJson).forEach(function (key) {
              let product = productsJson[key];
              if (product['sub_product_id'] == item.sub_product && product['id'] == item.product.id) {

                let form = {
                  order_id: order_id,
                  order_product_id: item.id,
                  quantity: product['quantity'],
                  user_id: user_id,
                }

                store.dispatch("ShoppingCart/changeQuantityWithoutState", form)

              }
            })
          })


        })

        this.$store.dispatch('ShoppingCart/userOrderUnpaid')
        localStorage.removeItem('products')

      }
    },
  },
  render() {
    return this.$scopedSlots.default({
      order: this.order,
      products: this.products,
      deliveryPrice: this.deliveryPrice,
      deliveryBoundary: this.deliveryBoundary,
      freeCities: this.freeCities,
      payDescript: this.payDescript,
      addresses: this.addresses,
    });
  },
  async mounted() {
    await this.setUnPayedOrder()
    await this.getUnAuthBasketItems(this.$store.getters["ShoppingCart/getSidebarBasketData"])
    await this.setAddress()
  },
}
</script>
